// extracted by mini-css-extract-plugin
module.exports = {"root":"whatYouGet_root__2f7CM","tight":"whatYouGet_tight__2Z9qA","rootInverted":"whatYouGet_rootInverted__3fLY7"};